import React from 'react';
import styles from "page/css/Exhibition.module.css";
import CommentatorSelect from "./CommentatorSelect";
import { useDispatch, useSelector } from "react-redux";
import { exhibitionActions } from "reducers/exhibition";

const ExhibitionFormCommentator = () => {
    const dispatch = useDispatch();
    const list = ['일반', '어린이', '시각장애인'];
    const type = useSelector(state => state.exhibitionData.type);
    const exhibitionRoom = useSelector(state => state.exhibitionData.exhibitionRoom);
    const commentatorList = useSelector(state => state.exhibitionData.commentatorList);

    const handleSelectGeneral = (e) => {
        if (exhibitionRoom) {
            dispatch(exhibitionActions.setExhibitionRoom({ ...exhibitionRoom, commentator: { id : e.target.value} }))
        }
    };
    const handleSelectForKid = (e) => {
        if (exhibitionRoom) {
            dispatch(exhibitionActions.setExhibitionRoom({ ...exhibitionRoom, commentatorForKid: { id : e.target.value} }))
        }
    }
    const handleSelectForBlind = (e) => {
        if (exhibitionRoom) {
            dispatch(exhibitionActions.setExhibitionRoom({ ...exhibitionRoom, commentatorForBlind: { id : e.target.value} }))
        }
    }
    const validation = (comm, exhibitionRoom, type) => {
        let result;
        if (type === "name") {
            switch (comm) {
                case list[0] :
                    result = "commentator";
                    break;
                case list[1] :
                    result = "commentatorForKid";
                    break;
                case list[2] :
                    result = "commentatorForBlind";
                    break;
                default :
                    result = null;
                    break;
            }
        } else if (type === "value") {
            switch (comm) {
                case list[0] :
                    if (exhibitionRoom.commentator.id === null) {
                        result = '';
                    } else result = exhibitionRoom.commentator.id || '';
                    break;
                case list[1] :
                    if (exhibitionRoom.commentatorForKid.id === null) {
                        result = '';
                    } else result = exhibitionRoom.commentatorForKid.id || '';
                    break;
                case list[2] :
                    if (exhibitionRoom.commentatorForBlind.id === null) {
                        result = '';
                    } else result = exhibitionRoom.commentatorForBlind.id || '';
                    break;
                default :
                    result = null;
                    break;
            }
        }
        return result;
    };

    return (
        <label className={styles.exhLabel}>
            {commentatorList.length >= 1
                ? type === "kor" ? (
                    <>
                        {list.map((comm, index)  => (
                            <div key={comm}>
                                <CommentatorSelect
                                    title={comm}
                                    list={commentatorList}
                                    name={validation(comm, exhibitionRoom, "name")}
                                    value={validation(comm, exhibitionRoom, "value")}
                                    onChange={comm === "일반" ? handleSelectGeneral : comm === "어린이" ? handleSelectForKid : comm === "시각장애인" ? handleSelectForBlind : null }
                                />
                            </div>
                        ))}
                    </>
                    ) : <CommentatorSelect name={"commentator"} value={exhibitionRoom?.commentator?.id !== null ? exhibitionRoom?.commentator?.id : null} title={"영문 해설자"} list={commentatorList} onChange={(e) => dispatch(exhibitionActions.setExhibitionRoom({ ...exhibitionRoom, commentator: { id: e.target.value } }))} />
                : <span className={"caption"}>해설자 관리에서 해설자를 등록해 주세요.</span>
            }
            </label>
    );
};

export default ExhibitionFormCommentator;